import { Content } from "@/interfaces/content";
import {
  PaymentWithUser,
  PlatformUserAccount,
  UserModificationRequest
} from "@/interfaces/payment";
import { Tenant } from "@/interfaces/tenants";
import BaseApiClient from "@/api/base";

export class TenantApiClient extends BaseApiClient {
  /* Tenant Requests */
  public listTenants(): Promise<Tenant[]> {
    return this.get("/tenants/");
  }

  public listContent(
    tenantId: string,
    type: string = "video"
  ): Promise<Content[]> {
    return this.get(`/tenant/${tenantId}/content`, {
      content_type: type,
      size: 1000
    });
  }

  public listUsers(tenantId: string): Promise<PlatformUserAccount[]> {
    return this.get(`/tenant/${tenantId}/users`);
  }

  public getUser(
    tenantId: string,
    userId: string
  ): Promise<PlatformUserAccount> {
    return this.get(`/tenant/${tenantId}/user/${userId}`);
  }

  public saveUser(
    tenantId: string,
    userId: string,
    modifications: UserModificationRequest
  ): Promise<PlatformUserAccount> {
    console.log(modifications);
    return this.post(`/tenant/${tenantId}/user/${userId}`, modifications);
  }

  public getCategories(
    tenantId: string,
    type: string = "video"
  ): Promise<string[]> {
    return this.get(`/tenant/${tenantId}/content/categories`, {
      content_type: type
    });
  }

  public getTags(tenantId: string, type: string = "video"): Promise<string[]> {
    return this.get(`/tenant/${tenantId}/content/tags`, {
      content_type: type
    });
  }

  public getBanktransfers(tenantId: string): Promise<PaymentWithUser[]> {
    return this.get(`/tenant/${tenantId}/get_bank_transfers`);
  }

  public acceptBanktransfer(
    tenantId: string,
    userId: string,
    bankTransferId: string
  ): Promise<PaymentWithUser[]> {
    return this.get(`/tenant/${tenantId}/accept_bank_transfer`, {
      user_id: userId,
      bank_transfer_id: bankTransferId
    });
  }

  public getContent(tenantId: string, contentId: string): Promise<Content> {
    return this.get(`/tenant/${tenantId}/content/${contentId}`);
  }

  public addVideo(tenantId: string): Promise<Content> {
    return this.get(`/tenant/${tenantId}/content/new_video`);
  }

  public deleteContent(tenantId: string, contentId: string): Promise<void> {
    return this.delete(`/tenant/${tenantId}/content/${contentId}`);
  }

  public saveContent(tenantId: string, content: Content): Promise<Content> {
    return this.post(
      `/tenant/${tenantId}/content/${content.content_id}`,
      content
    );
  }

  public uploadThumbnail(
    tenantId: string,
    contentId: string,
    formData: FormData,
    onUploadProgress?: (progressEvent: any) => void
  ): Promise<Content> {
    return this.post(
      `/tenant/${tenantId}/content/${contentId}/thumbnail`,
      formData,
      undefined,
      [],
      onUploadProgress,
      "multipart/form-data"
    );
  }

  public uploadVideo(
    tenantId: string,
    contentId: string,
    formData: FormData,
    onUploadProgress?: (progressEvent: any) => void
  ): Promise<Content> {
    return this.post(
      `/tenant/${tenantId}/content/${contentId}/video`,
      formData,
      undefined,
      [],
      onUploadProgress,
      "multipart/form-data"
    );
  }
}
